import React from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as CalendarIcon } from "assets/icons/calendar.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { defaultDateInputWrapperCss } from "./styles";
import { IDateInputProps } from "./types";

const DROPDOWN_YEARS = 100;
export const MIN_YEARS = 100;

export const DateInput = (props: IDateInputProps) => {
  const {
    name,
    value,
    label,
    labelClassName,
    id,
    onChange,
    placeholder,
    disabled,
    className,
    dateInputWrapperCss,
    preventOpenOnFocus,
    customCalendarIcon,
    minDate,
    maxDate,
  } = props;

  return (
    <Box css={{ ...defaultDateInputWrapperCss, ...dateInputWrapperCss }}>
      {label && (
        <label
          htmlFor="dateInput"
          className={`text-[#344054] font-medium text-[12px] leading-5 ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <DatePicker
        id={id}
        selected={value}
        onChange={onChange}
        name={name}
        placeholderText={placeholder || "DD-MM-YYYY"}
        disabled={disabled}
        icon={
          customCalendarIcon ? (
            customCalendarIcon
          ) : (
            <CalendarIcon className="cursor-pointer" />
          )
        }
        toggleCalendarOnIconClick
        className={className}
        preventOpenOnFocus={preventOpenOnFocus}
        showIcon
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={DROPDOWN_YEARS}
        minDate={minDate}
        maxDate={maxDate || new Date()}
        dateFormat="dd-MM-yyyy"
      />
    </Box>
  );
};

export default DateInput;
